class RecommendationProductsService {
    constructor(restangular) {
        this._api = restangular.one('/Recommendation');
    }

    getRecommendationPlacements(shouldBeSpecial, isInSmallFormat, message) {

        return this._api.get({
            isSpecial: shouldBeSpecial,
            isMobile: isInSmallFormat,
            recommendationMessage: message,
        });
    }
}

module.exports = RecommendationProductsService;



// WEBPACK FOOTER //
// ./src/shop/recommendation/recommendation-products.service.js